import { render, staticRenderFns } from "./magazine-supercard.vue?vue&type=template&id=1274fc82&"
var script = {}
import style0 from "./magazine-supercard.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports